import { Pipe, PipeTransform } from '@angular/core';
import { VirtualTagsService } from '@shared/services/virtual-tags.service';

@Pipe({
    name: 'tagRouterLink'
})
export class TagRouterLinkPipe implements PipeTransform {
    constructor(private tagsService: VirtualTagsService) {
    }

    transform(id: any, elementtype: any): any {
        return [this.tagsService.tagRouterLink(id as number, elementtype as string)];
    }
}
